module.exports = __webpack_public_path__ + "img/article-img.795071c5.png";